import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import CtaButton from 'components/essentials/Cta/CtaButton';
import useShowroomLocator from 'hooks/useShowroomLocator';
import useShowroomSearchInput from 'hooks/useShowroomSearchInput';
import CityStateSuggestionsDropdown from 'hooks/useCityStatePlacesAutocomplete/CityStateSuggestionsDropdown';
import ShowroomLocatorResults from './ShowroomLocatorResults';
const ShowroomLocatorContent = t0 => {
  const $ = _c(35);
  const {
    inputId: t1,
    className: t2,
    isMobile: t3,
    autoFocusInput: t4
  } = t0;
  const inputId = t1 === undefined ? "showroom-zipcode" : t1;
  const className = t2 === undefined ? "" : t2;
  const isMobile = t3 === undefined ? false : t3;
  const autoFocusInput = t4 === undefined ? false : t4;
  const zipInputRef = useRef();
  const formikRef = useRef();
  const {
    stores,
    loading,
    error,
    hasSearched,
    handleSearch,
    handleSearchByPlace,
    handleCloseResults,
    handleViewAll
  } = useShowroomLocator();
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = value => {
      formikRef.current?.setFieldValue("zipcode", value);
    };
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  const handleValueChange = t5;
  let t6;
  if ($[1] !== handleSearch || $[2] !== handleSearchByPlace) {
    t6 = {
      inputRef: zipInputRef,
      onValueChange: handleValueChange,
      onSearchByZipcode: handleSearch,
      onSearchByPlace: handleSearchByPlace
    };
    $[1] = handleSearch;
    $[2] = handleSearchByPlace;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const {
    notifyValueChanged,
    validateValue,
    submitValue,
    suggestionsDropdownProps
  } = useShowroomSearchInput(t6);
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      zipcode: ""
    };
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== validateValue) {
    t8 = values => {
      const message = validateValue(values.zipcode);
      return message ? {
        zipcode: message
      } : {};
    };
    $[5] = validateValue;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== submitValue) {
    t9 = t10 => {
      const {
        zipcode
      } = t10;
      submitValue(zipcode);
    };
    $[7] = submitValue;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== autoFocusInput || $[10] !== inputId || $[11] !== notifyValueChanged) {
    t10 = t11 => {
      const {
        values: values_0,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit
      } = t11;
      return <form onSubmit={handleSubmit}><LabeledTextInput id={inputId} name="zipcode" label="Zip Code or City, State" type="text" value={values_0.zipcode} onChange={event => {
          handleChange(event);
          notifyValueChanged(event.target.value);
        }} onBlur={handleBlur} errorMessage={touched.zipcode && errors.zipcode ? errors.zipcode : null} autoComplete="off" autoFocus={autoFocusInput} ref={zipInputRef} className="text-sm mb-1" action={<CtaButton type="submit" data-xc="FooterShowroomSearchButton" styling="solid-button" color="brand" size="sm" className="ml-2">Search</CtaButton>} actionHasPadding={false} actionStretchHeight={true} /></form>;
    };
    $[9] = autoFocusInput;
    $[10] = inputId;
    $[11] = notifyValueChanged;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t8 || $[15] !== t9) {
    t11 = <Formik innerRef={formikRef} initialValues={t7} validate={t8} onSubmit={t9}>{t10}</Formik>;
    $[13] = t10;
    $[14] = t8;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== suggestionsDropdownProps) {
    t12 = suggestionsDropdownProps && <CityStateSuggestionsDropdown {...suggestionsDropdownProps} />;
    $[17] = suggestionsDropdownProps;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="text-xs text-gray font-normal my-2">Within 50 miles</div>;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== error || $[21] !== handleCloseResults || $[22] !== hasSearched || $[23] !== isMobile || $[24] !== loading || $[25] !== stores) {
    t14 = hasSearched && <ShowroomLocatorResults loading={loading} error={error} stores={stores} onClose={handleCloseResults} isMobile={isMobile} />;
    $[20] = error;
    $[21] = handleCloseResults;
    $[22] = hasSearched;
    $[23] = isMobile;
    $[24] = loading;
    $[25] = stores;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== handleViewAll) {
    t15 = <div className="mt-3"><Link to="/showrooms/" onClick={handleViewAll} data-xc="FooterShowroomViewAllLink" className="text-brand underline text-sm !font-semibold">View All</Link></div>;
    $[27] = handleViewAll;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== className || $[30] !== t11 || $[31] !== t12 || $[32] !== t14 || $[33] !== t15) {
    t16 = <div className={className}>{t11}{t12}{t13}{t14}{t15}</div>;
    $[29] = className;
    $[30] = t11;
    $[31] = t12;
    $[32] = t14;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  return t16;
};
ShowroomLocatorContent.propTypes = {
  inputId: PropTypes.string,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
  autoFocusInput: PropTypes.bool
};
export default ShowroomLocatorContent;